<!-- Loading state -->
@if (loading) {
  <div class="loading-container">
    <loading-spinner></loading-spinner>
  </div>
}

<!-- Error state -->
@if (!loading && hasError) {
  <div class="error-container">
    <edu-card class="error-card">
      <mat-icon class="error-icon">error</mat-icon>
      <h2>Oops! Something went wrong</h2>
      <p>We couldn't load your issues at this time. Please try again later.</p>
      <button mat-raised-button color="primary" (click)="getIssues()">Try Again</button>
    </edu-card>
  </div>
}

<!-- Normal state with data -->
@if (!loading && !hasError) {
  <div>
    <edu-student-issues-card
      [readonly]="this.readonly"
      [issues]="issues"
      [username]="userName || 'N/A'"
      [studentName]="fullName || 'Unknown'">
    </edu-student-issues-card>
  </div>
}